import React from 'react';
import { cva } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  "inline-flex items-center gap-1 rounded-full font-medium transition-all duration-200",
  {
    variants: {
      variant: {
        default: "bg-neutral-100 text-neutral-800 hover:bg-neutral-200",
        primary: "bg-primary-100 text-primary-800 hover:bg-primary-200",
        success: "bg-green-100 text-green-800 hover:bg-green-200",
        completed: "bg-green-100 text-green-800 hover:bg-green-200",
        danger: "bg-red-100 text-red-800 hover:bg-red-200",
        warning: "bg-amber-100 text-amber-800 hover:bg-amber-200",
        info: "bg-blue-100 text-blue-800 hover:bg-blue-200",
        pending: "bg-amber-100 text-amber-800 hover:bg-amber-200",
        required: "bg-red-100 text-red-800 hover:bg-red-200",
        approved: "bg-green-100 text-green-800 hover:bg-green-200",
        rejected: "bg-red-100 text-red-800 hover:bg-red-200",
        outline: "border-2 border-neutral-300 bg-transparent text-neutral-700 hover:bg-neutral-50",
      },
      size: {
        sm: "px-2 py-0.5 text-xs",
        md: "px-2.5 py-0.5 text-sm",
        lg: "px-3 py-1 text-base",
      },
      dot: {
        true: "",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "md",
    },
  }
);

export const Badge = React.forwardRef(
  ({ className, variant, size, dot, icon, children, ...props }, ref) => (
    <span ref={ref} className={cn(badgeVariants({ variant, size, dot, className }))} {...props}>
      {dot && (
        <span
          className={cn(
            "h-1.5 w-1.5 rounded-full",
            (variant === "success" || variant === "completed" || variant === "approved") && "bg-green-500",
            (variant === "danger" || variant === "required" || variant === "rejected") && "bg-red-500",
            (variant === "warning" || variant === "pending") && "bg-amber-500",
            variant === "info" && "bg-blue-500",
            variant === "primary" && "bg-primary-500",
            variant === "default" && "bg-neutral-500"
          )}
          aria-hidden="true"
        />
      )}
      {icon && <span aria-hidden="true">{icon}</span>}
      {children}
    </span>
  )
);

Badge.displayName = "Badge";
